import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthService } from '../services/api';
import logo from '../assets/logo.png';
import Message from './Message';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const tokenFromUrl = searchParams.get('token');
        if (tokenFromUrl) {
            setToken(tokenFromUrl);
        } else {
            setError('Token de réinitialisation manquant ou invalide.');
        }
    }, [searchParams]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'password') {
            setPassword(value);
        } else if (name === 'confirmPassword') {
            setConfirmPassword(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        if (!password || !confirmPassword) {
            setError('Veuillez saisir et confirmer votre nouveau mot de passe.');
            setLoading(false);
            return;
        }

        if (password !== confirmPassword) {
            setError('Les mots de passe ne correspondent pas.');
            setLoading(false);
            return;
        }

        if (!token) {
            setError('Token de réinitialisation invalide. Veuillez refaire une demande.');
            setLoading(false);
            return;
        }

        try {
            await AuthService.resetPassword(token, password);
            setMessage('Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter.');
            // Vider les champs après succès
            setPassword('');
            setConfirmPassword('');
        } catch (err) {
            console.error('Erreur lors de la réinitialisation du mot de passe:', err);
            // 401 : lien expiré, ou déjà utilisé (un lien ne sert qu'une fois).
            setError(err.response?.status === 401
                ? 'Ce lien a expiré ou a déjà été utilisé. Veuillez refaire une demande.'
                : 'Une erreur est survenue lors de la réinitialisation. Veuillez vérifier votre lien ou réessayer.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="signin-container"> {/* Utilisation de la classe pour le style */}
            <img src={logo} alt="Logo de l'application" style={{ maxWidth: '150px', display: 'block', margin: '0px auto 20px auto' }} />
            <h2>Réinitialiser le mot de passe</h2>

            {message && <Message type="success">{message}</Message>}
            {error && <Message>{error}</Message>}

            {!message && token && ( // N'afficher le formulaire que si pas de message de succès et token présent
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="password">Nouveau mot de passe</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={password}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirmer le nouveau mot de passe</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Modification en cours...' : 'Modifier le mot de passe'}
                    </button>
                </form>
            )}

            {message && (
                <p>
                    <Link to="/signin">Se connecter</Link>
                </p>
            )}
            {!token && !error && <p>Vérification du token...</p>}
        </div>
    );
};

export default ResetPassword;